import ServiceTemplate from '../ServiceTemplate';

const TransferMortgage = () => {
  const serviceData = {
    title: 'גרירת משכנתא',
    description: 'העברת המשכנתא הקיימת לנכס חדש תוך שמירה על התנאים הטובים שהשגתם, עם ליווי מקצועי לאורך כל התהליך.',
    sections: [
      {
        title: 'מתי כדאי לגרור משכנתא?',
        content: 'גרירת משכנתא כדאית במיוחד כאשר תנאי המשכנתא הקיימת שלכם טובים יותר מהתנאים הנהוגים כיום בשוק, או כאשר אתם עוברים דירה ורוצים לשמור על ההטבות והתנאים שכבר השגתם. אנחנו נבצע השוואה מקיפה ונמליץ על המסלול המשתלם ביותר עבורכם.'
      },
      {
        title: 'איך התהליך עובד?',
        content: 'התהליך מתחיל בבדיקת כדאיות מקיפה של גרירת המשכנתא לעומת לקיחת משכנתא חדשה. נבחן את תנאי המשכנתא הקיימת, נשווה לתנאים העדכניים בשוק, ונחשב את כל העלויות הכרוכות בתהליך. לאחר מכן, נלווה אתכם בכל השלבים מול הבנק, כולל הכנת המסמכים הנדרשים והתאמת תנאי ההלוואה לנכס החדש.'
      }
    ],
    benefits: [
      'שמירה על תנאי ריבית טובים',
      'חיסכון בעלויות ועמלות',
      'אפשרות להגדלת המשכנתא',
      'ליווי מקצועי בתהליך',
      'בדיקת כדאיות מקיפה',
      'טיפול בכל הבירוקרטיה'
    ],
    faqs: [
      {
        question: 'האם תמיד כדאי לגרור משכנתא?',
        answer: 'לא תמיד. הכדאיות תלויה במספר גורמים כמו תנאי המשכנתא הקיימת, הריביות הנהוגות כיום בשוק, עלויות הגרירה, ומאפייני הנכס החדש. אנחנו נבצע ניתוח מקיף ונמליץ על האפשרות המשתלמת ביותר עבורכם.'
      },
      {
        question: 'כמה עולה לגרור משכנתא?',
        answer: 'עלות גרירת משכנתא כוללת מספר מרכיבים: אגרות רישום, דמי טיפול בנקאיים, הערכת שמאי לנכס החדש, ולעיתים עמלות נוספות. נעזור לכם להבין את כל העלויות מראש ולתכנן את התהליך בהתאם.'
      },
      {
        question: 'האם אפשר להגדיל את המשכנתא בעת הגרירה?',
        answer: 'כן, בהחלט. ניתן לגרור את המשכנתא הקיימת ובמקביל לקחת הלוואה נוספת בתנאים עדכניים. נעזור לכם לבנות את התמהיל האופטימלי שישלב בין שמירה על התנאים הטובים של המשכנתא הקיימת לבין מימון נוסף בתנאים אטרקטיביים.'
      },
      {
        question: 'כמה זמן לוקח תהליך גרירת משכנתא?',
        answer: 'תהליך גרירת משכנתא אורך בממוצע בין שבועיים לחודש, תלוי במורכבות המקרה ובמהירות השגת האישורים הנדרשים. אנחנו נלווה אתכם לאורך כל התהליך ונדאג שיתנהל ביעילות המרבית.'
      },
      {
        question: 'האם חייבים לגרור את כל המשכנתא?',
        answer: 'לא, ניתן לגרור רק חלק מהמשכנתא ולפרוע חלק אחר, או לקחת משכנתא חדשה על החלק שלא נגרר. נעזור לכם לבחון את כל האפשרויות ולבחור בפתרון המיטבי עבורכם.'
      }
    ],
    whatsappMessage: 'שלום, אני מתעניין/ת בגרירת משכנתא ואשמח לקבל מידע נוסף.'
  };

  return <ServiceTemplate {...serviceData} />;
};

export default TransferMortgage; 